import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as HubSettingsActions from 'store/actions/HubSettingsActions';

import { Button, Form, Row, Col } from 'react-bootstrap'
import { TextField } from '@material-ui/core';
import * as Logger from 'loglevel';
import authService from '../../api-authorization/AuthorizeService';
import Utilities from 'hub-utilities'
import Cookies from 'js-cookie';
import * as HubConstant from 'util/HubConstant';

import { faListAlt, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MultiValsSelector } from 'hub-dashboard-framework';

import { css } from "@emotion/core";
import ClipLoader from "react-spinners/ClipLoader";


function StoryForm(props) {
    const isEditMode = props.payload && props.payload.id; // Check if we're in edit mode
    // Slot above the General/Properties tabs, supplied by IntegratedNewsItemForm.
    const actionBarSlot = props.actionBarSlot || null;

    const [title, setTitle] = useState("");
    const [text, setText] = useState("");
    const [keywords, setKeywords] = useState("");
    const [fileName, setFileName] = useState(null);
    const [totalFileSize, setTotalFileSize] = useState(0);
    const [formError, setFormError] = useState(null);
    const [formStatus, setFormStatus] = useState();
    const [isSaving, setIsSaving] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [saveError, setSaveError] = useState(null);
    const [hasError, setHasError] = useState();
    const [isStatusEnabled, setIsStatusEnabled] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [attachments, setAttachments] = useState([]);
    const [isCreatingStory, setIsCreatingStory] = useState(false);
    const [isUpdatingStory, setIsUpdatingStory] = useState(false);
    const [isBrowseWindowOpen, setIsBrowseWindowOpen] = useState(false);
    const [isUrgent, setIsUrgent] = useState(false);
    const [isTextCollapsed, setIsTextCollapsed] = useState(false);
    const [editorActiveIndex, setEditorActiveIndex] = useState(-1);
    const [originalStoryData, setOriginalStoryData] = useState(null);

    const form = useRef(null);
    const storyTitle = useRef(null);
    const fileInputRef = useRef(null);

    useEffect(() => {
        async function setupForm() {
            if (isEditMode) {
                // Fetch story data if in edit mode
                await loadStoryData();
            } else {
                // Load cached data for new story mode
                await loadCachedData();
            }
        }

        setupForm();
    }, [props.payload]);

    useEffect(() => {
        const fetchSettings = async () => {
            if (!props.settings || !props.settings.maintenance || !props.settings.maintenance.media) {
                await props.startSettingsFetch(false);
            }
        }
        fetchSettings();
    }, []);

    useEffect(() => {
        if (storyTitle.current) {
            storyTitle.current.focus();
        }
    }, []);

    useEffect(() => {
        return () => {
            if (props.payload && props.payload.onFormClose) {
                props.payload.onFormClose();
            }
        };
    }, []);

    useEffect(() => {
        const submitForm = async () => {
            if (isCreatingStory) {
                await createStoryInFolder();
                setIsCreatingStory(false);
            } else if (isUpdatingStory) {
                await updateStoryInFolder();
                setIsUpdatingStory(false);
            }
        }

        submitForm();
    }, [isCreatingStory, isUpdatingStory]);

    const loadStoryData = async () => {
        try {
            const storyId = props.payload.id;
            Logger.debug("Loading story data for ID:", storyId);

            // Find the story in the object list
            const storyData = props.objectList.find(obj => obj.id === storyId);

            if (storyData) {
                Logger.debug("Found story data:", storyData);
                setOriginalStoryData(storyData);

                // Set form fields
                setTitle(storyData.name || "");

                // Get script safely
                let script = "";
                if (storyData.newsContent && storyData.newsContent.script) {
                    script = storyData.newsContent.script;
                }
                setText(script);

                setKeywords(storyData.keyword || "");
                setIsUrgent(storyData.priorityLevel === 5); // 5 is urgent, 7 is normal
                // Load existing media attachments if any
                if (storyData.newsContent && storyData.newsContent.elements && storyData.newsContent.elements.length > 0) {
                    const existingAttachments = storyData.newsContent.elements.map(element => {
                        // Get file size safely
                        let fileSize = 0;
                        if (element.newsContent && element.newsContent.size) {
                            fileSize = element.newsContent.size;
                        }

                        return {
                            elementId: element.id,
                            fileName: element.name,
                            fileSize: fileSize,
                            isExisting: true
                        };
                    });

                    setAttachments(existingAttachments);
                    setTotalFileSize(existingAttachments.reduce((total, file) => total + file.fileSize, 0));
                }

                // Load metadata/categories
                if (props.initializeNewsItemMetadata && typeof props.initializeNewsItemMetadata === 'function') {
                    await props.initializeNewsItemMetadata();
                }
            } else {
                setFormError("Could not find story data");
            }
        } catch (error) {
            Logger.error("Error loading story data:", error);
            setFormError("Error loading story data: " + error.message);
        }
    };

    const loadCachedData = async () => {
        var cachedTitle = await Cookies.get('CreateStoryTitle');

        var numOfBodyCookies = await Cookies.get('NumOfBodyCookies');
        var cachedText = "";
        if (!!numOfBodyCookies) {
            for (var i = 0; i < parseInt(numOfBodyCookies); i++) {
                cachedText += await Cookies.get(`CreateStoryBody${i}`);
            }
        }

        setTitle(!!cachedTitle ? cachedTitle : "")
        setText(!!cachedText ? cachedText : "")
    };

    const setEditorActiveIndexRow = (rowIndex) => {
        if (rowIndex === editorActiveIndex) {
            //Set editing row to none
            setEditorActiveIndex(-1);
        } else {
            setEditorActiveIndex(rowIndex);
        }
    };

    // Each cookie has 4096 byte limit (around 3900 characters)
    const cacheCreateStoryInfo = (stateName, val) => {
        // Only cache data in create mode, not edit mode
        if (isEditMode) return;

        if (stateName === 'title') {
            Cookies.set(`CreateStoryTitle`, val);
        }
        else if (stateName === 'text') {
            var infoArrs = Utilities.chunkInfoOnExceedByteLimit(val, 4096);
            for (var i = 0; i < infoArrs.length; i++) {
                Cookies.set(`CreateStoryBody${i}`, infoArrs[i]);
            }
            Cookies.set(`NumOfBodyCookies`, infoArrs.length);
        }
    };

    const clearCookies = async () => {
        var numOfBodyCookies = await Cookies.get('NumOfBodyCookies');
        if (!!numOfBodyCookies) {
            for (var i = 0; i < parseInt(numOfBodyCookies); i++) {
                Cookies.set(`CreateStoryBody${i}`, "");
            }
        }

        Cookies.set(`CreateStoryTitle`, "");
        Cookies.set('NumOfBodyCookies', "");
    };

    const validate = () => (form.current.reportValidity());

    const createStoryInFolder = async () => {
        setIsSaving(true);
        setSaveSuccess(false);
        setSaveError(null);

        //To prevent story from being double-created: 
        const response = await props.createNewsItemWithMetadataInFolder({
            name: title,
            text: text,
            newsObjectDesc: {
                keyword: keywords,
                priorityLevel: isUrgent ? 5 : 7
            },
            elements: attachments.filter(a => !a.isMarkedForDeletion).map(a => (a.elementId)),
        }, HubConstant.HUB_OBJECT_STORY, props.folderData.id);

        setIsSaving(false);

        if (response.ok) {
            let respObj = await response.json()
            Logger.debug(respObj)
            let story = respObj.hubObject;

            setSaveSuccess(true);

            if (!!props.onStoryCreated) {
                props.onStoryCreated(story);
            }
            if (!!props.onFormSubmitted) {
                props.onFormSubmitted();
            }
            clearCookies();
        }
        else {
            let respText = await response.text();
            const errorMsg = `Creating story failed: ${respText}`;
            setFormError(errorMsg);
            setSaveError(errorMsg);
        }
    };

    const updateStoryInFolder = async () => {
        setIsSaving(true);
        setSaveSuccess(false);
        setSaveError(null);

        const storyId = props.payload.id;

        const response = await props.updateNewsItemWithMetadataInFolder({
            id: storyId,
            name: title,
            text: text,
            newsObjectDesc: {
                keyword: keywords,
                priorityLevel: isUrgent ? 5 : 7
            },
            elements: attachments.filter(a => !a.isMarkedForDeletion).map(a => (a.elementId)),
        }, HubConstant.HUB_OBJECT_STORY, props.folderData.id);

        setIsSaving(false);

        if (response.ok) {
            let respObj = await response.json();
            Logger.debug("Story updated:", respObj);

            setSaveSuccess(true);
            if (props.onStoryUpdated) {
                props.onStoryUpdated(respObj.hubObject);
            }

            if (props.onFormSubmitted) {
                props.onFormSubmitted();
            }
        } else {
            const respText = await response.text();
            const errorMsg = `Updating story failed: ${respText}`;
            setFormError(errorMsg);
            setSaveError(errorMsg);
        }
    };

    const submitHandler = event => {
        event.preventDefault();
        event.target.className += " was-validated";

        setSaveSuccess(false);
        setSaveError(null);

        if (validate()) {
            if (isEditMode && !isUpdatingStory) {
                setIsUpdatingStory(true);
            } else if (!isEditMode && !isCreatingStory) {
                setIsCreatingStory(true);
            }
        }
    };

    const toggleStatus = (e) => {
        e.preventDefault();
        setIsStatusEnabled(!isStatusEnabled);
    };

    const changeHandler = event => {
        if (saveSuccess) {
            setSaveSuccess(false);
        }

        cacheCreateStoryInfo(event.target.name, event.target.value);
        switch (event.target.name) {
            case "title":
                setTitle(event.target.value);
                break;
            case "text":
                setText(event.target.value);
                break;
            case "keywords":
                setKeywords(event.target.value);
                break;
            default:
                break;
        }
    };

    const formatFileSize = (bytes, preferredUnit = null) => {
        if (bytes === 0) return '0 Bytes';

        if (preferredUnit && HubConstant.FILE_SIZE_UNITS[preferredUnit]) {
            const value = bytes / HubConstant.FILE_SIZE_UNITS[preferredUnit];
            return parseFloat(value.toFixed(2)) + ' ' + preferredUnit;
        }
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const fileUploadHandler = async event => {
        if (props.setIsBrowseWindowOpen) {
            props.setIsBrowseWindowOpen(false);
        }
        if (event.target.value.length == 0) {
            setFormError(null);
            setFileName(null);
            setFormStatus(null);
            return;
        }

        setFormStatus(null);

        try {
            const files = Array.from(event.target.files);

            const filesSize = files.reduce((total, file) => total + file.size, 0);
            const newTotalSize = totalFileSize + filesSize;

            const maxUploadSize = props.settings && props.settings.media && props.settings.media.maxUploadSize
                ? props.settings.media.maxUploadSize
                : 0;

            if (newTotalSize > maxUploadSize) {
                const preferredUnit = props.settings && props.settings.media && props.settings.media.preferredUnit;
                const formattedSize = formatFileSize(maxUploadSize, preferredUnit);
                setFormError(`Error: Total file size exceeds the limit of ${formattedSize}. Please select smaller files.`);
                setHasError(true);
                return;
            }

            setUploading(true);
            const uploadedFiles = [];

            for (const file of files) {
                Logger.debug(`Uploading file ${file.name} started`);

                let formData = new FormData();
                formData.append("file", file);
                let token = await authService.getAccessTokenAsync();

                const response = await fetch(`/api/CloudQ/1/file`, {
                    method: "POST",
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                    body: formData
                });

                if (response.ok) {
                    let respObject = await response.json();
                    let elementId = respObject.hubObject.id;
                    Logger.debug(`new media element ${elementId} created.`);
                    uploadedFiles.push({ elementId: elementId, fileName: file.name, fileSize: file.size });
                } else {
                    let respObject = await response.json();
                    setFormError(`Uploading ${file.name} failed: ${respObject.error}`);
                    setHasError(true);
                }
            }

            if (uploadedFiles.length > 0) {
                setTotalFileSize(prevSize => {
                    return uploadedFiles.reduce((total, file) => total + file.fileSize, prevSize);
                });

                setAttachments(prevAttachments => [...prevAttachments, ...uploadedFiles]);
                setFileName(uploadedFiles.map(f => f.fileName).join(', '));
                setFormError(null);
            }
        } catch (error) {
            setFormError(`Upload failed: ${error.message}`);
            setHasError(true);
            setFileName(null);
        } finally {
            setUploading(false);
        }
    };

    const removeAttachment = (elementId) => {
        if (saveSuccess) {
            setSaveSuccess(false);
        }

        setAttachments(prevAttachments => {
            return prevAttachments.map(attachment => {
                if (attachment.elementId === elementId) {
                    // Mark for deletion but keep in the array until form submission
                    return { ...attachment, isMarkedForDeletion: true };
                }
                return attachment;
            });
        });
    };

    const setCategoriesToSelect = (newArr) => {
        var categories = props.getCategory();
        if (!!categories) {
            props.onLocalResetNewsItemMetadata(categories.fieldId, newArr.map(val => {
                return { index: val.id, value: val.name }
            }));
        }
    };

    const renderCategory = () => {
        var availableCategories = props.getCategory();
        var chosenCategoriesState = !!props.storyMetadata ? props.storyMetadata.find(mdata => mdata.fieldId === 1) : null;

        return (
            !!availableCategories && !!chosenCategoriesState ?
                <>
                    <div className="multiValsSelectorWrapper">
                        <MultiValsSelector
                            id={0}
                            title={availableCategories.fieldName}
                            toggleIcon={faListAlt}
                            availableVals={availableCategories.vocabulary.map(vocab => { return { id: vocab.index, name: vocab.keyword } })}
                            selectedVals={chosenCategoriesState.values.map(value => { return { id: value.index, name: value.value } })}
                            setSelectedVals={setCategoriesToSelect}
                        />
                    </div>
                </>
                : <></>
        );
    };

    const handleAddMediaClick = () => {
        if (props.setIsBrowseWindowOpen) {
            props.setIsBrowseWindowOpen(true);
        }
        fileInputRef.current.click();
    };

    const saveButtonLoaderOverride = css`
    position: relative;
    margin-right: 8px;`;

    const getButtonContent = () => {
        if (isSaving) {
            return (
                <>
                    <ClipLoader
                        size={16}
                        color={"#ffffff"}
                        css={saveButtonLoaderOverride}
                    />
                    {isEditMode ? "Updating..." : "Creating..."}
                </>
            );
        }

        if (saveSuccess) {
            return `${isEditMode ? "Updated" : "Created"} ✓`;
        }

        return isEditMode ? "Update" : "Create";
    };

    const getButtonClass = () => {
        let baseClass = "storySubmitButton";

        if (uploading || isSaving) {
            baseClass += " disabled";
        }

        if (saveSuccess) {
            baseClass += " btn-success";
        } else if (saveError) {
            baseClass += " btn-danger";
        }

        return baseClass;
    };

    const collapsibleLoaderOverride = css`
        position: relative;
        margin-top: 5px !important;
        margin-bottom: 0px !important;`;

    const uploadMediaButtonOverride = css`
        position: relative;
        margin-top: 0 !important;`;

    /* removeAttachment only flags isMarkedForDeletion — the entry stays in
       `attachments` until submit so the save can delete it server-side. Anything
       user-facing has to count this filtered list, not attachments.length. */
    const visibleAttachments = attachments.filter(a => !a.isMarkedForDeletion);

    let uploadedAttachments = null;
    if (visibleAttachments.length > 0) {
        let fileList = visibleAttachments
            .map(a => {
                let mimeType = "Unknown";
                let fileType = "Unknown";
                let fileSize = a.fileSize || 0;

                if (a.isExisting && originalStoryData && originalStoryData.newsContent) {
                    const element = originalStoryData.newsContent.elements.find(e => e.id === a.elementId);
                    if (element && element.newsContent) {
                        if (element.newsContent.type) {
                            mimeType = element.newsContent.type.mimeType || "Unknown";
                            fileType = element.newsContent.type.type || "Unknown";
                        }
                        fileSize = element.newsContent.fileSize || a.fileSize || 0;
                    }
                }

                const fileExtension = a.fileName.split('.').pop().toUpperCase();

                const formattedSize = formatFileSize(fileSize,
                    props.settings && props.settings.media && props.settings.media.preferredUnit || null);

                return (
                    <div key={a.elementId} className="attachment-item">
                        <div className="attachment-content">
                            <div className="attachment-info">
                                <span className="attachment-name">{a.fileName}</span>
                                <span className="attachment-details">
                                    <span className="attachment-type">{fileType}</span>
                                    <span className="attachment-size">{formattedSize}</span>
                                </span>
                            </div>
                            <button
                                type="button"
                                className="attachment-remove-btn"
                                onClick={() => removeAttachment(a.elementId)}
                                title="Remove file"
                                disabled={isSaving}
                            >
                                <span>×</span>
                            </button>
                        </div>
                    </div>
                );
            });
        uploadedAttachments = <div className="attachments-container"><div className="attachments-title">Uploaded files:</div>{fileList}</div>;
    }

    /* Built here so it keeps this component's state (attachments, saving,
       errors), then portalled into the slot above the tabs, which the parent
       renders. The portal moves it out of the <form> in the DOM, so the submit
       button carries form="storyDetailsForm" to stay associated with it.
       Falls back to rendering inline if there is no slot. */
    const actionBar = (
            <div className="storyActionBar">
                {isSaving && (
                    <div className="statusMsg saving">
                        <ClipLoader
                            size={16}
                            color={"#007bff"}
                            css={css`margin-right: 8px;`}
                        />
                        {isEditMode ? "Updating story..." : "Creating story..."}
                    </div>
                )}

                {saveSuccess && (
                    <div className="statusMsg success">
                        ✓ Story {isEditMode ? "updated" : "created"} successfully!
                    </div>
                )}

                {(formError || saveError) && (
                    <div className="errorMsg">
                        {saveError || formError}
                    </div>
                )}
                <div className="storyActionBarButtons">
                    <Button
                        className={`uploadMediaButton ${uploading ? "uploading" : ""}`}
                        onClick={handleAddMediaClick}
                        style={{ pointerEvents: "auto" }}
                        disabled={isSaving}
                    >
                        {uploading ? (
                            <ClipLoader
                                size={20}
                                color={"#f69b1d"}
                                css={uploadMediaButtonOverride}
                            />
                        ) : (
                            visibleAttachments.length > 0
                                ? `Add Media (${visibleAttachments.length})`
                                : "Add Media"
                        )}
                    </Button>
                    <Button
                        className={getButtonClass()}
                        type="submit"
                        form="storyDetailsForm"
                        size="sm"
                        disabled={uploading || isSaving}
                    >
                        {getButtonContent()}
                    </Button>
                </div>
            </div>
    );

    return (
        <div>
            <Form id="storyDetailsForm" ref={form} className={`needs-validation StoryDetailsForm ${isSaving ? 'saving' : ''}`} onSubmit={submitHandler} >
                <Row className="ImportantInfoRow">
                    <Col xs="10">
                        <TextField
                            ref={storyTitle}
                            value={title}
                            name="title"
                            onChange={changeHandler}
                            type="text"
                            id="storyTitle"
                            className="form-control"
                            label="Story Title"
                            disabled={isSaving}
                            required
                        />
                    </Col>
                    <Col xs="2" className="LargeCheckbox">
                        <div className="formTitle">Urgent?</div>
                        <label
                            className='checkboxContainer'
                        >
                            <input
                                id={`UrgencyCheckbox`}
                                name={`UrgencyCheckbox`}
                                className="filterGroupChild"
                                label=""
                                type="checkbox"
                                onChange={() => {
                                    var newUrgency = !isUrgent;
                                    setIsUrgent(newUrgency);
                                }}
                                checked={isUrgent}
                                disabled={isSaving}
                            />
                            <span className='checkmark large' />
                        </label>
                    </Col>
                </Row>
                <div className="invalid-feedback">
                    Please provide a title for the story.
                </div>
                <div className="valid-feedback">Looks good!</div>
                {actionBarSlot ? null : actionBar}
                <div className="storyTextSection">
                    <button
                        type="button"
                        className={`storyTextToggle ${isTextCollapsed ? "collapsed" : ""}`}
                        onClick={() => setIsTextCollapsed(!isTextCollapsed)}
                        aria-expanded={!isTextCollapsed}
                        aria-controls="storyText"
                    >
                        <FontAwesomeIcon className="storyTextChevron" icon={faChevronDown} />
                        <span className="storyTextLabel">Text</span>
                    </button>
                    {/* Unmounted rather than hidden when collapsed: `text` lives in
                        React state so nothing is lost, and .form-control's
                        display:block would fight the hidden attribute. */}
                    {!isTextCollapsed && (
                        <textarea
                            value={text}
                            name="text"
                            onChange={changeHandler}
                            id="storyText"
                            className="form-control"
                            placeholder="Story Text"
                            rows="6"
                            disabled={isSaving}
                        />
                    )}
                </div>
                {renderCategory()}
                <TextField
                    value={keywords}
                    name="keywords"
                    onChange={changeHandler}
                    type="text"
                    id="storyKeyword"
                    className="form-control storyKeyword"
                    label="Tags"
                    disabled={isSaving}
                    InputLabelProps={{
                        style: {
                            zIndex: 9999
                        },
                    }}
                />
                <input
                    ref={fileInputRef}
                    type="file"
                    style={{ display: "none" }}
                    onChange={fileUploadHandler}
                    onClick={() => {
                        if (props.setIsBrowseWindowOpen) {
                            props.setIsBrowseWindowOpen(true);
                        }
                    }}
                    className="custom-file-input"
                    id="inputGroupFile01"
                    aria-describedby="inputGroupFileAddon01"
                    disabled={isSaving}
                    multiple
                />
                {visibleAttachments.length > 0 ? <div className="uploadedMediaFileDisplay">
                    {uploadedAttachments}
                </div> : <div></div>}
            </Form >
            {actionBarSlot ? ReactDOM.createPortal(actionBar, actionBarSlot) : null}
        </div >
    );
}

const mapStateToProps = state => {
    return {
        settings: state.hubConfig.hubSettings.settings,
        objectList: state.hubObjectContent.objectList
    };
};

export default withRouter(connect(
    mapStateToProps,
    dispatch => bindActionCreators({
        ...HubSettingsActions.mapSettingsDispatcherToProps,
    }, dispatch)
)(StoryForm));